var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.gruposNormalizados),function(group){return _c('div',{key:group.id,staticClass:"rounded-full mr-1 mb-1 pl-1 pr-1 border-2",class:[
        group.idTipo === 1 ? 'bg-primary-800 dark:bg-darkblue text-white group-pool' : 
        group.idTipo === 2  ? 'bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 group-border' : 
        group.idTipo === 3  ? 'bg-secondary-600 dark:bg-secondary-600 text-white group-reparto' : ''
      ]},[_c('GroupTagTooltip',{attrs:{"group":group}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }